module.exports = __webpack_public_path__ + "img/Thinking_to_molecule_thinking.21e61813.gif";